import { getLocalStorage } from '@shared/core';

const KEY = 'shareable-dialog-viewed';

interface Args {
  copy?: () => Promise<void>;
  copyWithLink?: (generatedLink: string) => void;
  generatedLink?: string | null;
  openDialog: () => void;
}

const useHandleCopyShareableLink = (args: Args) => {
  const { openDialog, copy, copyWithLink, generatedLink } = args;
  const localStorage = getLocalStorage();

  return async () => {
    if (!localStorage.getItem(KEY)) {
      openDialog();
      localStorage.setItem(KEY, 'true');
    } else if (copyWithLink && generatedLink) {
      copyWithLink(generatedLink);
    } else {
      await copy?.();
    }
  };
};

export default useHandleCopyShareableLink;
